"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseLibrary = void 0;
__exportStar(require("./types"), exports);
//TODO Refactor libraries estructure. We have maybe reduntant classes or interfaces
class BaseLibrary {
    constructor() {
        this.instance = null;
    }
    getLibrary() {
        if (!this.instance) {
            throw Error(`${this.constructor.name}: Library is not loaded, try to create it and load`);
        }
        return this.instance;
    }
}
exports.BaseLibrary = BaseLibrary;
//# sourceMappingURL=index.js.map